// DEPENDENCIES
import axios from "axios";
import dayjs from "dayjs";

import { postAPICall } from "../config/apiCalls";

// LOGS
export const addToAutomationLog = async (
	instance,
	account,
	employeeID,
	successStatus,
	message,
	toolName
) => {
	try {
		await postAPICall(instance, account, "/api/logs/automation/add", {
			employeeID: employeeID,
			date_time: dayjs().format("MMMM D, YYYY h:mm:ss A"),
			message: message,
			success: successStatus,
			tool_name: toolName,
		});
	} catch (error) {
		console.log("Error in addToAutomationLog: ", error);
	}
};

export const addToAccessLog = async (employeeID, toolName, notes) => {
	if (process.env.REACT_APP_NODE_ENV === "development") {
		return;
	}

	try {
		const res = await axios.get("/api/logs/access/add", {
			params: {
				page_name: toolName,
				employeeID: employeeID,
				date_time: dayjs().format("MMMM D, YYYY h:mm:ss A"),
				notes: notes,
			},
		});
	} catch (error) {
		console.log("Error in addToAccessLog: ", error);
	}
};
